import { createContext, useContext } from "react";
import { TourId } from "./types";

export interface TourContextValue {
  startTour: (id: TourId) => void;
  stopTour: () => void;
  resetTour: (id: TourId) => void;
  markCompleted: (id: TourId) => void;
  isCompleted: (id: TourId) => boolean;
  activeTourId: TourId | null;
}

const noop = () => undefined;

export const TourContext = createContext<TourContextValue>({
  startTour: noop,
  stopTour: noop,
  resetTour: noop,
  markCompleted: noop,
  isCompleted: () => false,
  activeTourId: null
});

export function useTour(): TourContextValue {
  return useContext(TourContext);
}
